module.exports = function(app) {
    app.directive('reviewList', function() {

        return {
            restrict: 'A',
            replace: true,
            scope: {
                reviews: '=reviews',
                limit: '='
            },
            template: require('directives/reviewList.html'),

            link: function(scope) {

                var formatLocaleTime = function (d) {

                        var weekday = [],
                            monthday = [],
                            day,
                            month,
                            date,
                            year;

                            Date.fromISO = function(s) {

                                var D = new Date('2011-06-02T09:34:29+02:00');

                                if (!D || +D !== 1307000069000) {
                                    var day, tz,
                                        rx = /^(\d{4}\-\d\d\-\d\d([tT ][\d:\.]*)?)([zZ]|([+\-])(\d\d):(\d\d))?$/,
                                        p = rx.exec(s) || [];

                                    if (p[1]) {
                                        day = p[1].split(/\D/);
                                        for (var i = 0, L = day.length; i < L; i++) {
                                            day[i] = parseInt(day[i], 10) || 0;
                                        }
                                        day[1] -= 1;
                                        day = new Date(Date.UTC.apply(Date, day));
                                        if (!day.getDate()) {
                                            return NaN;
                                        }
                                        if (p[5]) {
                                            tz = (parseInt(p[5], 10) * 60);
                                            if (p[6]) {
                                                tz += parseInt(p[6], 10);
                                            }
                                            if (p[4] == '+') {
                                                tz *= -1;
                                            }
                                            if (tz) {
                                                day.setUTCMinutes(day.getUTCMinutes() + tz);
                                            }
                                        }
                                        return day;
                                    }
                                    return NaN;
                                } else {
                                    return new Date(d);
                                }
                            };

                        d = Date.fromISO(d);

                        day = d.getDay();
                        month = d.getMonth();
                        date = d.getDate();
                        year = d.getFullYear();

                        weekday[0] = 'Sunday';
                        weekday[1] = 'Monday';
                        weekday[2] = 'Tuesday';
                        weekday[3] = 'Wednesday';
                        weekday[4] = 'Thursday';
                        weekday[5] = 'Friday';
                        weekday[6] = 'Saturday';

                        monthday[0] = 'Jan';
                        monthday[1] = 'Feb';
                        monthday[2] = 'Mar';
                        monthday[3] = 'Apr';
                        monthday[4] = 'May';
                        monthday[5] = 'Jun';
                        monthday[6] = 'Jul';
                        monthday[7] = 'Aug';
                        monthday[8] = 'Sep';
                        monthday[9] = 'Oct';
                        monthday[10] = 'Nov';
                        monthday[11] = 'Dec';

                        return weekday[day] + ', ' + monthday[month] + ' ' + date + ', ' + year;

                    },

                    normalizeReviews = function (reviews) {
                        var obj = {},
                            results = [],
                            key;

                        if (reviews.length) {
                            for (var i=0;i<reviews.length;i++) {
                                obj = angular.copy(reviews[i]);
                                obj.questions = {};

                                obj.timestamp = obj.review_timestamp.substring(0,10) + 'T' + scope.reviews[i].review_timestamp.substr(11) + 'Z';
                                obj.timestamp = obj.review_timestamp ? formatLocaleTime(obj.timestamp) : 'Unknown date';

                                if (obj.answers.length) {
                                    for (var j=0;j<obj.answers.length;j++) {
                                        key = obj.answers[j].question;
                                        obj.questions[key] = obj.answers[j];
                                    }
                                }
                                results.push(obj);
                            }
                        }
                        return results;
                    };

                scope.reviews = scope.reviews ? normalizeReviews(scope.reviews) : [];

                for (var i=0;i<scope.reviews.length;i++) {

                    scope.reviews[i].dynamicQuestions = [];

                    angular.forEach(scope.reviews[i].questions, function (key, value) {
                        if (value !== 'Screenname' && value !== 'Comments' && value !== 'Headline') {
                            this.push(key);
                        }
                    }, scope.reviews[i].dynamicQuestions);

                }
            },
            controller: ['$scope', 'services', 'session', function ($scope, services, session) {

                $scope.rateReview = function (positive, id) {
                    if (services && services.dpsext && services.dpsext.rateReview) {
                        if (positive) {
                            services.dpsext.rateReview({type: 'reviewlikews'}).create({
                                review_id: id,
                                reviewer_token: session.data.memberInfo.bvUserId
                            }).then(function (res) {
                                for (var i = 0; i < $scope.reviews.length; i++) {
                                    $scope.reviews[i].message = '';
                                    if ($scope.reviews[i].review_id === id) {
                                        if (res.data.result_code === 'S') {
                                            $scope.reviews[i].likes = null;
                                            $scope.reviews[i].likes = res.data.like_count;
                                            $scope.reviews[i].status = 'liked';
                                            $scope.reviews[i].message = 'Success';
                                        } else {
                                            $scope.reviews[i].message = res.data.result_msg;
                                        }
                                    }
                                }
                            }, function () {
                                for (var i=0;i<$scope.reviews.length;i++) {
                                    $scope.reviews[i].message = '';
                                    if ($scope.reviews[i].review_id === id) {
                                        $scope.reviews[i].message = 'Failed to like review';
                                    }
                                }
                            });
                        } else {
                            services.dpsext.rateReview({type: 'reviewdislikews'}).create({
                                review_id: id,
                                reviewer_token: session.data.memberInfo.bvUserId
                            }).then(function (res) {
                                for (var i = 0; i < $scope.reviews.length; i++) {
                                    $scope.reviews[i].message = '';
                                    if ($scope.reviews[i].review_id === id) {
                                        if (res.data.result_code === 'S') {
                                            $scope.reviews[i].dislikes = null;
                                            $scope.reviews[i].dislikes = res.data.dislike_count;
                                            $scope.reviews[i].status = 'disliked';
                                            $scope.reviews[i].message = 'Success';
                                        } else {
                                            $scope.reviews[i].message = res.data.result_msg;
                                        }
                                    }
                                }
                            }, function () {
                                for (var i=0;i<$scope.reviews.length;i++) {
                                    $scope.reviews[i].message = '';
                                    if ($scope.reviews[i].review_id === id) {
                                        $scope.reviews[i].message = 'Failed to like review';
                                    }
                                }
                            });
                        }
                    }
                };
            }]
        };
    });
};